import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'submitContainer',
    (theme, [multiplePages]) => [
      `
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin: 30px auto;
			width: 300px;

			&:first-of-type {
				margin: 0 auto;
			}
		`,
      multiplePages &&
        `
			height: 100%;
		`
    ]
  ],
  [
    'info',
    `
		margin-bottom: 60px;
	`
  ]
]);
